import {
  ADD_COUNTDOWN_CLOCK,
  ADD_COUNTDOWN_CLOCK_FAILED,
  ADD_COUNTDOWN_CLOCK_SUCCESS,
  DELETE_COUNTDOWN_CLOCK,
  DELETE_COUNTDOWN_CLOCK_FAILED,
  DELETE_COUNTDOWN_CLOCK_SUCCESS,
  GET_COUNTDOWN_CLOCK,
  GET_COUNTDOWN_CLOCK_FALIED,
  GET_COUNTDOWN_CLOCK_LIST,
  GET_COUNTDOWN_CLOCK_LIST_FAILED,
  GET_COUNTDOWN_CLOCK_LIST_SUCCESS,
  GET_COUNTDOWN_CLOCK_SUCCESS,
  HIDE_DELETE_COUNTDOWN_CLOCK_MODAL,
  OPEN_DELETE_COUNTDOWN_CLOCK_MODAL,
  RESET_COUNTDOWN_CLOCK,
  RESET_COUNTDOWN_CLOCK_LIST,
  UPDATE_COUNTDOWN_CLOCK,
  UPDATE_COUNTDOWN_CLOCK_FAILED,
  UPDATE_COUNTDOWN_CLOCK_ORDER,
  UPDATE_COUNTDOWN_CLOCK_ORDER_FAILED,
  UPDATE_COUNTDOWN_CLOCK_ORDER_SUCCESS,
  UPDATE_COUNTDOWN_CLOCK_STATUS,
  UPDATE_COUNTDOWN_CLOCK_STATUS_FAILED,
  UPDATE_COUNTDOWN_CLOCK_STATUS_SUCCESS,
  UPDATE_COUNTDOWN_CLOCK_SUCCESS,
} from "./actionTypes"

export const getCountdownClockList = params => ({
  type: GET_COUNTDOWN_CLOCK_LIST,
  payload: { params },
})

export const getCountdownClockListSuccess = response => ({
  type: GET_COUNTDOWN_CLOCK_LIST_SUCCESS,
  payload: response,
})

export const getCountdownClockListFailed = error => ({
  type: GET_COUNTDOWN_CLOCK_LIST_FAILED,
  payload: error,
})

export const addCountdownClock = params => ({
  type: ADD_COUNTDOWN_CLOCK,
  payload: params,
})

export const addCountdownClockSuccess = response => ({
  type: ADD_COUNTDOWN_CLOCK_SUCCESS,
  payload: response,
})

export const addCountdownClockFailed = error => ({
  type: ADD_COUNTDOWN_CLOCK_FAILED,
  payload: error,
})

export const getCountdownClock = params => ({
  type: GET_COUNTDOWN_CLOCK,
  payload: { params },
})

export const getCountdownClockSuccess = response => ({
  type: GET_COUNTDOWN_CLOCK_SUCCESS,
  payload: response,
})

export const getCountdownClockFailed = error => ({
  type: GET_COUNTDOWN_CLOCK_FALIED,
  payload: error,
})

export const resetCountdownClock = () => ({
  type: RESET_COUNTDOWN_CLOCK,
  payload: {},
})

export const updateCountdownClock = params => ({
  type: UPDATE_COUNTDOWN_CLOCK,
  payload: params,
})

export const updateCountdownClockSuccess = response => ({
  type: UPDATE_COUNTDOWN_CLOCK_SUCCESS,
  payload: response,
})

export const updateCountdownClockFailed = error => ({
  type: UPDATE_COUNTDOWN_CLOCK_FAILED,
  payload: error,
})

export const updateCountdownClockOrder = params => ({
  type: UPDATE_COUNTDOWN_CLOCK_ORDER,
  payload: params,
})

export const updateCountdownClockOrderSuccess = response => ({
  type: UPDATE_COUNTDOWN_CLOCK_ORDER_SUCCESS,
  payload: response,
})

export const updateCountdownClockOrderFailed = error => ({
  type: UPDATE_COUNTDOWN_CLOCK_ORDER_FAILED,
  payload: error,
})

export const updateCountdownClockStatus = params => ({
  type: UPDATE_COUNTDOWN_CLOCK_STATUS,
  payload: params,
})

export const updateCountdownCLockStatusSuccess = response => ({
  type: UPDATE_COUNTDOWN_CLOCK_STATUS_SUCCESS,
  payload: response,
})

export const updateCountdownClockStatusFailed = error => ({
  type: UPDATE_COUNTDOWN_CLOCK_STATUS_FAILED,
  payload: error,
})

export const openDeleteCountdownClockModal = () => ({
  type: OPEN_DELETE_COUNTDOWN_CLOCK_MODAL,
  payload: {},
})

export const hideDeleteCountdownClockModal = () => ({
  type: HIDE_DELETE_COUNTDOWN_CLOCK_MODAL,
  payload: {},
})

export const deleteCountdownClock = params => ({
  type: DELETE_COUNTDOWN_CLOCK,
  payload: params,
})

export const deleteCountdownClockSuccess = response => ({
  type: DELETE_COUNTDOWN_CLOCK_SUCCESS,
  payload: response,
})

export const deleteCountdownClockFailed = error => ({
  type: DELETE_COUNTDOWN_CLOCK_FAILED,
  payload: error,
})

export const resetCountdownClockList = () => ({
  type: RESET_COUNTDOWN_CLOCK_LIST,
  payload: {},
})
